import codes from "../../errorCodes/Recognition"

export default function recognitionErrorHandler(code: string) {
  switch (code) {
    case codes.ErrNotEnoughPeople:
      return "errors.PBRECNotEnoughPeople"
    case codes.ErrInvalidArguments:
      return "errors.PBRECInvalidArguments"
    case codes.ErrNotFound:
      return "errors.PBRECNotFound"
    case codes.ErrUnauthorized:
      return "errors.PBRECUnauthorized"
    case codes.ErrAlreadyExists:
      return "errors.PBRECAlreadyExists"
    case codes.ErrDBPing:
      return "errors.PBRECDBPing"
    case codes.ErrUnknown:
    default:
      return ""
  }
}
